import { useState, useContext } from "react";
import { Link } from "react-scroll";
import { NavLink } from "react-router-dom";
import { motion } from 'framer-motion';
import "./MainNavigation.css";

import Button from '../shared/components/FormElements/Button/Button';
import SideDrawer from "../shared/components/Navigation/SideDrawer";
import Backdrop from "../shared/components/UIElements/Backdrop";
import { AuthContext } from "../shared/context/auth-context";

const MainNavigation = () => {
  const auth = useContext(AuthContext);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const openDrawerHandler = () => {
      setDrawerOpen(true);
  };

  const closeDrawerHandler = () => {
      setDrawerOpen(false);
  };
  return (
    <div className="header">
      <div className="logo">
        <Button to={'/home'} transparent>
        <div className="vaceai5">VACE.AI</div>
        </Button>
      </div>
      {drawerOpen && <Backdrop onClick={closeDrawerHandler}/>}
      {!auth.isLoggedIn && 
      <div className="menus1">
        <div className="services2"><Link to='services' smooth={true}>SERVICES</Link></div>
        <div className="pricing3"><Link to='pricing' smooth={true}>PRICING</Link></div>
        <div className="pricing3"><Link to='faq' smooth={true}>FAQ</Link></div>
        <div className="pricing3"><Link to='contact' smooth={true}>CONTACT</Link></div>
      </div>
      }
      {auth.isLoggedIn && 
      <div className="nav-links">
        <div className="services2"><NavLink to={`/user/${auth.userId}/interviews`}>INTERVIEW</NavLink></div>
        <div className="pricing3"><NavLink to={`/user/${auth.userId}/detail`}>RESUME</NavLink></div>
        <div className="waitlist1">
          <div className="sign-up"><Button to={'/account'} transparent><p style={{ marginBottom: 0, marginTop: 0, letterSpacing: '0.2rem', color: 'black' }}>ACCOUNT</p></Button></div>
        </div>
      </div>
      }
      <SideDrawer show={drawerOpen} onClick={closeDrawerHandler}>
      {!auth.isLoggedIn && 
      <div className="menu-wrapper">
        <div className="menus1-col">
          <div className="services2-col"><Link to='services' smooth={true}>SERVICES</Link></div>
          <div className="pricing3-col"><Link to='pricing' smooth={true}>PRICING</Link></div>
          <div className="pricing3-col"><Link to='faq' smooth={true}>FAQ</Link></div>
          <div className="pricing3-col"><Link to='contact' smooth={true}>CONTACT</Link></div>
          <div className="signup5-col">
            <div className="sign-up2"><Button to={'/auth'} transparent><p style={{ color: '#ffffff', marginBottom: 0, marginTop: 0 }}>SIGN UP</p></Button></div>
          </div>
        </div>
      </div>
      }
      {auth.isLoggedIn && 
      <div className="nav-links-col">
        <div className="services2"><NavLink to={`/user/${auth.userId}/interviews`}>INTERVIEW</NavLink></div>
        <div className="pricing3"><NavLink to={`/user/${auth.userId}/detail`}>RESUME</NavLink></div>
        <div className="logout-col">
          <div className="sign-up2"><Button to={'/account'} transparent><p style={{ marginBottom: 0, marginTop: 0, letterSpacing: '0.2rem', color: 'black' }}>ACCOUNT</p></Button></div>
        </div>
      </div>
      }
      </SideDrawer>
      {!auth.isLoggedIn && 
      <motion.div 
        className="signup5"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
      >
        <div className="sign-up2"><Button to={'/auth'} transparent><p style={{ color: '#ffffff', marginBottom: 0, marginTop: 0, fontSize: '16px' }}>SIGN UP</p></Button></div>
      </motion.div>
      }
      <div className="three_lines">
      <Button onClick={openDrawerHandler} transparent>
      <div className="three_lines">
        <span />
        <span />
        <span />
      </div>
      </Button>
      </div>
    </div>
  );
};

export default MainNavigation;
